import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import MembersFilter from './member-filter';
import { MembersSortFieldDesktop } from '../../components/member-sort-field';
import { VerticalSeparator } from '../../components/separator';
import styles from './member-header-desktop.scss';

const MemberHeaderDesktop = ({ sort, onSortChange, filter, onFilterChange, membersCount }) =>
  <div className={classNames(styles.container, 'forum-card-background-color')}>
    <div className={classNames(styles.borders, 'forum-text-border-color')}/>
    <MembersFilter className={styles.filter} value={filter} onChange={onFilterChange} count={membersCount}/>
    <VerticalSeparator/>
    <MembersSortFieldDesktop className={styles.sort} value={sort} onChange={onSortChange}/>
    <VerticalSeparator/>
  </div>;

MemberHeaderDesktop.propTypes = {
  sort: PropTypes.string.isRequired,
  onSortChange: PropTypes.func.isRequired,
  filter: PropTypes.string,
  onFilterChange: PropTypes.func.isRequired,
  membersCount: PropTypes.number,
};

export default MemberHeaderDesktop;



// WEBPACK FOOTER //
// ./app/components/member-header/member-header-desktop.js